import { of as observableOf, Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { SessionData } from '../../data/system/session';

@Injectable()
export class SessionService extends SessionData {

  constructor() {
    super();
  }

  deleteUserSession(): Observable<boolean> {
    this.deleteCampusSession();
    this.deleteBudgetFundCategoryInputParamSession();
    this.deleteBudgetFundCategoryInputTypeAndDescriptionSession();
    this.deleteBudgetFundCategoryDescriptionFunctionSession();
    this.deleteObligationInputParamSession();
    this.deleteObligationTypeAndDescriptionSession();
    this.deleteSABAUDBReportParams();
    this.deleteExpirationTime();
    return observableOf(true);
  }

  // campus
  setCampusSession(campus: number): Observable<boolean> {
    localStorage.setItem('campus', campus.toString());
    return observableOf(true);
  }

  deleteCampusSession(): Observable<boolean> {
    localStorage.removeItem('campus');
    return observableOf(true);
  }

  getCampusSession(): Observable<number> {
    const raw_campus = localStorage.getItem('campus');
    const campus = (raw_campus != null) ? Number(localStorage.getItem('campus')) : null;
    return observableOf(campus);
  }

  // // budget fund category accounts
  // getBudgetFundCategoryAccountSession(): Observable<Array<any>> {
  //   const account = JSON.parse(localStorage.getItem('budget_fund_category.account'));
  //   return observableOf(account);
  // }

  // setBudgetFundCategoryAccountSession(account: Array<any>): Observable<boolean> {
  //   localStorage.setItem('budget_fund_category.account', JSON.stringify(account));
  //   return observableOf(true);
  // }

  // deleteBudgetFundCategoryAccountSession(): Observable<boolean> {
  //   localStorage.removeItem('budget_fund_category.account');
  //   return observableOf(true);
  // }

  // ========== BUDGET FUND CATEGORY ========== 
  // input params
  getBudgetFundCategoryInputParamSession(): Observable<any> {
    const params = JSON.parse(localStorage.getItem('budget_fund_category.params'));
    return observableOf(params);
  }

  setBudgetFundCategoryInputParamSession(params: any): Observable<boolean> {
    localStorage.setItem('budget_fund_category.params', JSON.stringify(params));
    return observableOf(true);
  }

  deleteBudgetFundCategoryInputParamSession(): Observable<boolean> {
    localStorage.removeItem('budget_fund_category.params');
    return observableOf(true);
  }

  // type description
  getBudgetFundCategoryInputTypeAndDescriptionSession(): Observable<Array<any>> {
    const typeDesc = JSON.parse(localStorage.getItem('budget_fund_category.typeDesc'));
    return observableOf(typeDesc);
  }

  setBudgetFundCategoryInputTypeAndDescriptionSession(type_desc: Array<any>): Observable<boolean> {
    localStorage.setItem('budget_fund_category.typeDesc', JSON.stringify(type_desc));
    return observableOf(true);
  }

  deleteBudgetFundCategoryInputTypeAndDescriptionSession(): Observable<boolean> {
    localStorage.removeItem('budget_fund_category.typeDesc');
    return observableOf(true);
  }

  // description function
  getBudgetFundCategoryDescriptionFunctionSession(): Observable<Array<any>> {
    const descFunc = JSON.parse(localStorage.getItem('budget_fund_category.descFunc'));
    return observableOf(descFunc);
  }

  setBudgetFundCategoryDescriptionFunctionSession(desc_func: Array<any>): Observable<boolean> {
    localStorage.setItem('budget_fund_category.descFunc', JSON.stringify(desc_func));
    return observableOf(true);
  }

  deleteBudgetFundCategoryDescriptionFunctionSession(): Observable<boolean> {
    localStorage.removeItem('budget_fund_category.descFunc');
    return observableOf(true);
  }
  // ========================================== 


  // ========== OBLIGATION LIST =============== 
  // input params
  getObligationInputParamSession(): Observable<Array<any>> {
    const descFunc = JSON.parse(localStorage.getItem('obligation_list.params')); return observableOf(descFunc);
  }

  setObligationInputParamSession(params: any): Observable<boolean> {
    localStorage.setItem('obligation_list.params', JSON.stringify(params)); return observableOf(true);
  }

  deleteObligationInputParamSession(): Observable<boolean> {
    localStorage.removeItem('obligation_list.params'); return observableOf(true);
  }

  // type and description
  getObligationTypeAndDescriptionSession(): Observable<Array<any>> {
    const descFunc = JSON.parse(localStorage.getItem('obligation_list.typeDesc')); return observableOf(descFunc);
  }

  setObligationTypeAndDescriptionSession(type_desc: Array<any>): Observable<boolean> {
    localStorage.setItem('obligation_list.typeDesc', JSON.stringify(type_desc)); return observableOf(true);
  }

  deleteObligationTypeAndDescriptionSession(): Observable<boolean> {
    localStorage.removeItem('obligation_list.typeDesc'); return observableOf(true);
  }
  // ========================================== 


  // ========== SABAUDB REPORT ================ 
  getSABAUDBReportParams(): Observable<Array<any>> {
    const sabaudb_report_params = JSON.parse(localStorage.getItem('sabaudb_report_params')); return observableOf(sabaudb_report_params);
  }

  setSABAUDBReportParams(params: any): Observable<boolean> {
    localStorage.setItem('sabaudb_report_params', JSON.stringify(params)); return observableOf(true);
  }

  deleteSABAUDBReportParams(): Observable<boolean> {
    localStorage.removeItem('sabaudb_report_params'); return observableOf(true);
  }
  // ========================================== 


  // ========== expiration date ===============
  setExiprationTime(timestamp: number): Observable<boolean> {
    localStorage.setItem('token_expiration', JSON.stringify(timestamp)); return observableOf(true);
  }

  getExpirationTime(): Observable<any> {
    return observableOf(JSON.parse(localStorage.getItem('token_expiration')));
  }

  deleteExpirationTime(): Observable<boolean> {
    localStorage.removeItem('token_expiration'); return observableOf(true);
  }
  // ==========================================
}
